import { render, staticRenderFns } from "./HowToPay.vue?vue&type=template&id=93638b34&"
import script from "./HowToPay.vue?vue&type=script&lang=js&"
export * from "./HowToPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports